import React from 'react';
import { getSessionStorage, isClient } from '../../../../../../../utils';
import { PRICE_FILTER } from '../../../constants/QuickFilters.constants';

const QuickFilterList = ({
  RenderComponent,
  options = [],
  setUpdatedUrlActn,
  isFacetedNavigationEnabled,
  seoFacetedNavigationConfig,
  cleanUrlObj,
  pathName,
  formDetails,
  input,
  appliedFilters,
  facetName,
  filterMaps,
  handleFilterSelection,
  filterName,
}) => {
  const priceMinInitial = 'pMinInitial';
  const priceMaxInitial = 'pMaxInitial';
  const priceOptions = {};
  if (facetName === PRICE_FILTER) {
    priceOptions.pMinInitial = isClient() && getSessionStorage(priceMinInitial);
    priceOptions.pMaxInitial = isClient() && getSessionStorage(priceMaxInitial);
  }
  return (
    <>
      {options?.map((filter, index) => (
        <RenderComponent
          checked={false}
          label={filter?.displayName}
          disabled={false}
          key={`quick-filter-${filter.displayName}`}
          item={filter}
          setUpdatedUrlActn={setUpdatedUrlActn}
          isFacetedNavigationEnabled={isFacetedNavigationEnabled}
          seoFacetedNavigationConfig={seoFacetedNavigationConfig}
          cleanUrlObj={cleanUrlObj}
          pathName={pathName}
          formDetails={formDetails}
          handleClick={handleFilterSelection}
          index={index}
          optionsMap={options}
          input={input}
          appliedFilters={appliedFilters}
          facetName={facetName}
          filterMaps={filterMaps}
          filterName={filterName}
          priceOptions={priceOptions}
        />
      ))}
    </>
  );
};

export default QuickFilterList;
